import { RegistrationManager } from '../RegistrationManager';
import { Headers } from '../types';
import { ApiClientFactory } from './clients';

export class RegistrationManagerFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/registration`, headers);
  }

  public createRegistrationManager() {
    return new RegistrationManager(this.apiClientFactory.createClient());
  }
}
